import { Vue, Options } from 'vue-class-component';

@Options({
	name: 'LinkComponent',
	components: {},
	props: {
		to: { type: String, required: false },
		target: String,
		externalIcon: { type: Boolean, default: false },
		smallIcon: { type: Boolean, default: false },
		xSmallIcon: { type: Boolean, default: false },
		alternateIcon: { type: Boolean, default: false },
	},
})
export default class LinkComponent extends Vue {
	to: string;
	target: string;
	externalIcon: boolean;
	smallIcon: boolean;
	xSmallIcon: boolean;
	alternateIcon: boolean;
}
